import { render, staticRenderFns } from "./SystemInit.vue?vue&type=template&id=08cfd030&scoped=true"
import script from "./SystemInit.vue?vue&type=script&lang=js"
export * from "./SystemInit.vue?vue&type=script&lang=js"
import style0 from "./SystemInit.vue?vue&type=style&index=0&id=08cfd030&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cfd030",
  null
  
)

export default component.exports